import { map } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { AuthAction } from '@cbridge-packages/auth';
import { UserSettingsAction } from '../userSettings.action';

/** Clears the in-memory settings on logout, so the next login never reads another user's layout. */
export const destroyUserSettingsOnLogoutEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(AuthAction.logout),
  map(() => UserSettingsAction.destroy()),
);
